module.exports = __webpack_public_path__ + "img/p26.f536f00a.gif";